
import React from 'react';
import { useTranslation } from '../hooks/useTranslation';

interface HeroProps {
  isB2BView: boolean;
}

const Hero: React.FC<HeroProps> = ({ isB2BView }) => {
  const { t } = useTranslation();

  const b2cBg = 'https://papirrullen.clientdemo.app/assets/images/koala1.jpg';
  const b2bBg = 'https://papirrullen.clientdemo.app/assets/images/papirrullen-facs.png';

  return (
    <section 
      id="home" 
      className="relative flex items-center justify-center h-screen bg-cover bg-center transition-all duration-500" 
      style={{ backgroundImage: `url(${isB2BView ? b2bBg : b2cBg})` }}
    >
      <div className="absolute inset-0 bg-black/20 dark:bg-black/40 backdrop-blur-sm"></div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-4xl md:text-6xl font-serif font-bold text-brand-dark dark:text-white tracking-tight">
          {isB2BView ? t('b2b_hero_title') : t('hero_title')}
        </h1>
        <p className="mt-4 max-w-2xl mx-auto text-lg md:text-xl text-brand-dark dark:text-slate-200">
          {isB2BView ? t('b2b_hero_subtitle') : t('hero_subtitle')}
        </p>
        <div className="mt-8 flex justify-center">
          {isB2BView ? (
             <a 
                href="/#/products"
                className="block bg-brand-green text-white font-bold text-lg px-8 py-3 rounded-lg shadow-lg hover:bg-opacity-90 dark:hover:bg-opacity-90 transition-all duration-300"
              >
                {t('shop_now_btn')}
              </a>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-2xl mx-auto">
              <a 
                href="/#/products"
                className="block bg-brand-green text-white font-bold text-lg px-8 py-3 rounded-lg shadow-lg hover:bg-opacity-90 dark:hover:bg-opacity-90 transition-all duration-300"
              >
                {t('shop_now_btn')}
              </a>
              <a 
                href="/#/subscription"
                className="block bg-brand-green text-white font-bold text-lg px-8 py-3 rounded-lg shadow-lg hover:bg-opacity-90 dark:hover:bg-opacity-90 transition-all duration-300"
              >
                {t('subscribe_now_btn')}
              </a>
              <a 
                href="/"
                className="block bg-brand-green text-white font-bold text-lg px-8 py-3 rounded-lg shadow-lg hover:bg-opacity-90 dark:hover:bg-opacity-90 transition-all duration-300"
              >
                {t('b2b_btn')}
              </a>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default Hero;
